import styled from '@emotion/styled'

import { Color, theme } from '../../../../constants'
import { Flex } from '../../../../elements'
import { Cell } from '../components/Cell'
import { Row } from '../components/Row'
import { useSchedule } from '../useSchedule'

const Body = styled(Flex)({
  background: Color.BACKGROUND_GREY,
  height: theme.spacing[2],
  width: '100%',
})

export const Divider = () => {
  const { columnCount } = useSchedule()

  return (
    <Row>
      <Cell style={{ padding: 0, height: 0 }} colSpan={columnCount} isTitle>
        <Body />
      </Cell>
    </Row>
  )
}
